import { render, staticRenderFns } from "./DiseaseParentChildList.vue?vue&type=template&id=f3e99c58&scoped=true"
import script from "./DiseaseParentChildList.vue?vue&type=script&lang=js"
export * from "./DiseaseParentChildList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3e99c58",
  null
  
)

export default component.exports